import { createContext, useRef , useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
    children: React.ReactNode;
}


export const PathCheckerComponent = ({ children }: Props) => {
  const tabIdRef = useRef(Date.now()); // Unique tab ID
  const navigate = useNavigate();

  useEffect(() => {
      const currentTabPath = window.location.pathname;
      const tabId = tabIdRef.current;
      const channel = new BroadcastChannel('tab-communication'); // Create a broadcast channel

      // Function to send messages
      const sendMessage = (action: string, path: string) => {
          channel.postMessage({ action, path, tabId });
      };

      // Handle messages from other tabs
       // Handle messages from other tabs
      const handleMessage = (event: MessageEvent) => {
        const message = event.data;
        if (message.tabId === tabId) return; // Ignore messages from self

        if (message.action === 'TAB_OPENED' && message.path === currentTabPath) {
            console.log(`Another tab with path ${currentTabPath} detected. Informing current tab.`);
            sendMessage('TAB_EXIST', currentTabPath); // Notify current tab
        }
        if (message.action === 'TAB_EXIST' && message.path === currentTabPath) {
            console.log(`Current tab informed that another tab exists. Redirecting...`);
            navigate('/empty');
        }
      };

      // Listen for messages
      channel.addEventListener('message', handleMessage);

      // Announce this tab
      sendMessage('TAB_OPENED', currentTabPath);

      // Cleanup on unmount
      return () => {
          channel.removeEventListener('message', handleMessage);
          channel.close(); // Close the channel when component unmounts
      };
  }, []);

    return (
        <div>
            {children}
        </div>
    );  
};

export default PathCheckerComponent;
